(function () {
  function init(section) {
    var track = section.querySelector('[data-edit-track]');
    if (!track) return;
    var prev = section.querySelector('[data-edit-prev]');
    var next = section.querySelector('[data-edit-next]');
    var amount = function () {
      return Math.max(track.clientWidth * 0.25, 280);
    };
    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -amount(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: amount(), behavior: 'smooth' });
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-featured-edit]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('[data-featured-edit]')) init(event.target.querySelector('[data-featured-edit]'));
  });
})();
